<mat-dialog-content>
  <spb-kalp-uc-info/>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="outlined" matDialogClose>Stäng</button>
</mat-dialog-actions>
